itsoftApp.createModule("lazyLoading", ["windowResize", "windowScroll", "scrollTo"], function () {
    const module = this;
    window.lazyQueue = [];
    window.lazyInitQueue = function () {
        if (!window.lazyQueue.length) {
            return;
        }

        while (window.lazyQueue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            window.lazyQueue.shift()();
        }
    }

    let checking = false;

    window.lazyFunctions = {
        slider: function (element) {
            let sliderSettingsKey = element.getAttribute("data-slider-settings"); // получаем data-атрибут
            const sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

            if (sliderSettingsKey && sliderSettingsObject) {
                new itsoftApp.modules.slidersLibrary.callback(element, sliderSettingsObject);
            } else {
                new itsoftApp.modules.slidersLibrary.callback(element);
            }
        },
        tabs: function (element) {
            new itsoftApp.modules.toggleTabs.callback.init(element);
        },
        scrollTrigger: function (element) {
            itsoftApp.modules.scrollActions.callback(element, true, false);
        },
        accordion: function (element) {
            new itsoftApp.modules.accordion.callback(element);
        },

        loadItems: function (element) {
            itsoftApp.modules.loadItems.initLoad(element);
        },

        loadItemsWithFilters: function (element) {
            itsoftApp.modules.loadItemsWithFilters.initLoad(element);
        },

        uteka: function (element) {
            itsoftApp.modules.utekaInit.callback(element);
            itsoftApp.modules.uteka.callback(element);
        },

        videoPopup: function (element) {
            itsoftApp.modules.videoPopup.init(element);
        },

        problem: function (element) {
            itsoftApp.modules.problem.init(element);
        },
    };

    function executeLazyFunction(element) {
        var lazyFunctionName = element.getAttribute("data-lazy-function");
        var lazyFunction = window.lazyFunctions[lazyFunctionName];
        if (!lazyFunction) return;
        lazyFunction(element);
    }

    const Lazy = function () {
        this.path = "/assets/scripts/vanilla-lazyload/lazyload.min.js";

        this.init();
    };

    Lazy.prototype.setSettings = function () {
        window.llEarlier = new LazyLoad({
            unobserve_entered: true,
            elements_selector: ".lazyload-earlier",
            class_loaded: "loaded",
            class_entered: "entered",
            thresholds: "-100% 0px"
        });

        window.ll = new LazyLoad({
            // unobserve_entered: true,
            elements_selector: ".lazy, .lazyload",
            class_loaded: "loaded",
            class_entered: "entered",
            cancel_on_exit: true
        });

        window.llCallRequestOptions = {
            unobserve_entered: true,
            class_loaded: "loaded",
            class_entered: "entered"
        }

        window.llCallRequest = new LazyLoad(window.modalOptions);

        window.llCallback = new LazyLoad({
            unobserve_entered: true,
            elements_selector: ".lazy-script, .js-script",
            class_entered: "js-script-entered",
            callback_enter: executeLazyFunction
        });

        new LazyLoad({
            unobserve_entered: true,
            elements_selector: ".js-anim",
            class_entered: "js-anim--show",
            thresholds: "0px 0px"
        });

        new LazyLoad({
            unobserve_entered: true,
            elements_selector: ".js-anim-custom",
            class_entered: "js-anim-custom--show",
            thresholds: "-30% 0px"
        });
    };

    Lazy.prototype.init = function () {
        itsoftApp.loadScript(this.path, this.setSettings);
    };

    new Lazy();
    module.callback = Lazy;
});
